module.exports = __webpack_public_path__ + "static/media/showcase.10400541.svg";